export default {
  path: '/quality_check_value_types',
  name: 'quality_check_value_types',
  component: () => import('../components/qualitycheckvaluetype/Layout'),
  redirect: { name: 'QualityCheckValueTypeList' },
  meta: {
    breadcrumb: 'qualitycheck.value.types',
  },
  children: [
    {
      name: 'QualityCheckValueTypeList',
      path: '',
      component: () => import('../views/qualitycheckvaluetype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'QualityCheckValueTypeCreate',
      path: 'new',
      component: () => import('../views/qualitycheckvaluetype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'QualityCheckValueTypeUpdate',
      path: ':id/edit',
      component: () => import('../views/qualitycheckvaluetype/Update'),
      meta: {
        breadcrumb: 'qualitycheck.value.type',
      },
    },
    {
      name: 'QualityCheckValueTypeShow',
      path: ':id',
      component: () => import('../views/qualitycheckvaluetype/Show'),
      meta: {
        breadcrumb: 'qualitycheck.value.type',
      },
    }
  ]
};
